import store from '../store/Store';

const showVideoModal = (id) => {
  store.commit('Popups/setVideoModalEmbed', id)
  store.commit('Popups/togglePopups', 'Video')
}

export const PlayButton = () => {
  const $btn = document.querySelectorAll('.js--play-button');

  $btn.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();

      const videoId = this.dataset.youtubeEmbedId;
      if (videoId !== undefined && videoId.length > 0) {
        showVideoModal(videoId);
      }
    })
  });
}
